import 'react-image-lightbox/style.css';
import { Box, styled, CardContent, alpha, Card, Typography, CardActionArea, Grid } from '@mui/material';
import React, { Fragment, forwardRef, useState, useImperativeHandle, createRef, Component } from 'react';
import ReactImageLightBox from 'react-image-lightbox';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var AspectRatioBox = function AspectRatioBox(_ref) {
  var children = _ref.children,
    ratio = _ref.ratio;
  if (!ratio) {
    return React.createElement(Fragment, null, children);
  }
  return React.createElement(Box, {
    position: 'relative'
  }, React.createElement(Box, {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    style: {
      '& > *': {
        height: '100%',
        width: '100%'
      }
    }
  }, children), React.createElement(Box, {
    style: {
      paddingBottom: 1 / ratio * 100 + '%'
    }
  }));
};
var LightBox = function LightBox(_ref, ref) {
  var _images;
  var images = _ref.images,
    reactModalStyle = _ref.reactModalStyle;
  var _useState = useState(null),
    currentIndex = _useState[0],
    setCurrentIndex = _useState[1];
  useImperativeHandle(ref, function () {
    return {
      open: function open(index) {
        setCurrentIndex(index);
      }
    };
  });
  var handleClose = function handleClose() {
    setCurrentIndex(null);
  };
  var handleChangeImage = function handleChangeImage(direction) {
    return function () {
      setCurrentIndex(function (prevCurrentIndex) {
        return prevCurrentIndex + direction === 'prev' ? (prevCurrentIndex + images.length - 1) % images.length : (prevCurrentIndex + 1) % images.length;
      });
    };
  };
  if (currentIndex === null) {
    return React.createElement(Fragment, null);
  }
  return React.createElement("div", null, React.createElement(ReactImageLightBox, {
    imageTitle: images[currentIndex].title,
    reactModalStyle: reactModalStyle,
    mainSrc: images[currentIndex].img,
    nextSrc: (_images = images[(currentIndex + 1) % images.length]) === null || _images === void 0 ? void 0 : _images.img,
    prevSrc: images[(currentIndex + images.length - 1) % images.length].img,
    onCloseRequest: handleClose,
    onMovePrevRequest: handleChangeImage('prev'),
    onMoveNextRequest: handleChangeImage('next')
  }));
};
var LightBox$1 = forwardRef(LightBox);
var CoverStyle = styled('img')(function () {
  return {
    objectFit: 'cover',
    width: '100%',
    height: '100%'
  };
});
var MoreHoverStyle = styled(CardContent)(function (_ref) {
  var theme = _ref.theme;
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    color: theme.palette.common.white,
    backgroundColor: alpha(theme.palette.grey[900], 0.6)
  };
});
var ORIENTATION;
(function (ORIENTATION) {
  ORIENTATION[ORIENTATION["VERTICAL"] = 0] = "VERTICAL";
  ORIENTATION[ORIENTATION["HORIZONTAL"] = 1] = "HORIZONTAL";
})(ORIENTATION || (ORIENTATION = {}));
var ImagesGrid = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ImagesGrid, _Component);
  function ImagesGrid(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this._handleImageLoad = function () {
      var fistImageRef = _this._fistImage.current;
      if (!fistImageRef) {
        return;
      }
      var fistImagePosition = fistImageRef.naturalHeight > fistImageRef.naturalWidth ? ORIENTATION.VERTICAL : ORIENTATION.HORIZONTAL;
      if (fistImagePosition !== _this.state.fistImagePosition) {
        _this.setState(function (prevState) {
          return _extends({}, prevState, {
            fistImagePosition: fistImageRef.naturalHeight > fistImageRef.naturalWidth ? ORIENTATION.VERTICAL : ORIENTATION.HORIZONTAL
          });
        });
      }
    };
    _this._handleImageClick = function (imageIndex) {
      var _this$_lightBoxRef$cu;
      (_this$_lightBoxRef$cu = _this._lightBoxRef.current) === null || _this$_lightBoxRef$cu === void 0 ? void 0 : _this$_lightBoxRef$cu.open(imageIndex);
    };
    _this._HoverMoreRender = function (_ref2) {
      var imageCount = _ref2.imageCount;
      return React.createElement(MoreHoverStyle, null, React.createElement(Typography, {
        variant: "h4",
        component: 'span'
      }, "+", imageCount - 5));
    };
    _this._OneImageRender = function (_ref3) {
      var _ref3$image = _ref3.image,
        title = _ref3$image.title,
        img = _ref3$image.img,
        imgThumbnail = _ref3$image.imgThumbnail;
      return React.createElement(CardActionArea, {
        onClick: function onClick() {
          return _this._handleImageClick(0);
        }
      }, React.createElement(Grid, {
        container: true
      }, React.createElement(Grid, {
        item: true,
        xs: 12
      }, React.createElement(CoverStyle, {
        alt: title,
        src: imgThumbnail || img
      }))));
    };
    _this._TowImageRender = function (_ref4) {
      var images = _ref4.images;
      return React.createElement(Grid, {
        container: true,
        spacing: 0.2
      }, images.map(function (_ref5, index) {
        var title = _ref5.title,
          img = _ref5.img,
          imgThumbnail = _ref5.imgThumbnail;
        return React.createElement(Grid, {
          key: index + "-" + img,
          item: true,
          xs: 6
        }, React.createElement(CardActionArea, {
          onClick: function onClick() {
            return _this._handleImageClick(index);
          }
        }, React.createElement(AspectRatioBox, {
          ratio: 1
        }, React.createElement(CoverStyle, {
          alt: title,
          src: imgThumbnail || img
        }))));
      }));
    };
    _this._ThreeAndMoreImageRender = function (_ref6) {
      var images = _ref6.images;
      var imageCount = images.length;
      if (_this.state.fistImagePosition === ORIENTATION.HORIZONTAL || imageCount > 4) {
        return React.createElement(Grid, {
          container: true,
          spacing: 0.2
        }, React.createElement(Grid, {
          item: true,
          xs: 12,
          height: '100%'
        }, React.createElement(Grid, {
          container: true,
          spacing: 0.2
        }, images.slice(0, imageCount < 5 ? 1 : 2).map(function (_ref7, index) {
          var title = _ref7.title,
            img = _ref7.img,
            imgThumbnail = _ref7.imgThumbnail;
          return React.createElement(Grid, {
            key: index + "-" + img,
            item: true,
            xs: imageCount < 5 ? 12 : 6
          }, React.createElement(CardActionArea, {
            onClick: function onClick() {
              return _this._handleImageClick(index);
            }
          }, React.createElement(AspectRatioBox, {
            ratio: imageCount < 5 ? undefined : 1
          }, React.createElement(CoverStyle, {
            ref: index === 0 ? _this._fistImage : undefined,
            alt: title,
            src: imgThumbnail || img,
            onLoad: index === 0 ? _this._handleImageLoad : undefined
          }))));
        }))), React.createElement(Grid, {
          item: true,
          xs: 12
        }, React.createElement(Grid, {
          container: true,
          spacing: 0.2
        }, images.slice(imageCount < 5 ? 1 : 2, 5).map(function (_ref8, index) {
          var title = _ref8.title,
            img = _ref8.img,
            imgThumbnail = _ref8.imgThumbnail;
          return React.createElement(Grid, {
            key: index + "-" + img,
            item: true,
            xs: imageCount === 3 ? 6 : 4
          }, React.createElement(CardActionArea, {
            onClick: function onClick() {
              return _this._handleImageClick(index + (imageCount < 5 ? 1 : 2));
            }
          }, React.createElement(AspectRatioBox, {
            ratio: 1
          }, React.createElement(CoverStyle, {
            alt: title,
            src: imgThumbnail || img
          })), index === 2 && imageCount > 5 && _this._HoverMoreRender({
            imageCount: imageCount
          })));
        }))));
      }
      var imageFirst = images[0];
      return React.createElement(AspectRatioBox, {
        ratio: 1
      }, React.createElement(Grid, {
        container: true,
        spacing: 0.2
      }, React.createElement(Grid, {
        item: true,
        xs: imageCount === 3 ? 6 : 8
      }, React.createElement(CardActionArea, {
        sx: {
          height: '100%'
        },
        onClick: function onClick() {
          return _this._handleImageClick(0);
        }
      }, React.createElement(CoverStyle, {
        ref: _this._fistImage,
        alt: imageFirst.title,
        src: imageFirst.imgThumbnail || imageFirst.img,
        onLoad: _this._handleImageLoad
      }))), React.createElement(Grid, {
        item: true,
        xs: imageCount === 3 ? 6 : 4
      }, React.createElement(Grid, {
        container: true,
        spacing: 0.2
      }, images.slice(1).map(function (_ref9, index) {
        var title = _ref9.title,
          img = _ref9.img,
          imgThumbnail = _ref9.imgThumbnail;
        return React.createElement(Grid, {
          key: index + "-" + img,
          item: true,
          xs: 12
        }, React.createElement(CardActionArea, {
          onClick: function onClick() {
            return _this._handleImageClick(index + 1);
          }
        }, React.createElement(AspectRatioBox, {
          ratio: 1
        }, React.createElement(CoverStyle, {
          alt: title,
          src: imgThumbnail || img
        })), index === 2 && imageCount > 5 && _this._HoverMoreRender({
          imageCount: imageCount
        })));
      })))));
    };
    _this._SelectorRender = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        _OneImageRender = _assertThisInitialize._OneImageRender,
        _TowImageRender = _assertThisInitialize._TowImageRender,
        _ThreeAndMoreImageRender = _assertThisInitialize._ThreeAndMoreImageRender;
      var images = _this.props.images;
      var imageCount = images.length;
      if (imageCount === 1) {
        return React.createElement(_OneImageRender, {
          image: images[0]
        });
      } else if (imageCount === 2) {
        return React.createElement(_TowImageRender, {
          images: images
        });
      } else if (imageCount > 2) {
        return React.createElement(_ThreeAndMoreImageRender, {
          images: images
        });
      }
      return React.createElement(Fragment, null);
    };
    _this._fistImage = createRef();
    _this._lightBoxRef = createRef();
    _this.state = {
      fistImagePosition: undefined,
      lightBox: null
    };
    return _this;
  }
  var _proto = ImagesGrid.prototype;
  _proto.render = function render() {
    var _SelectorRender = this._SelectorRender,
      _lightBoxRef = this._lightBoxRef;
    var _this$props = this.props,
      images = _this$props.images,
      reactModalStyle = _this$props.reactModalStyle;
    return React.createElement(Card, null, React.createElement(_SelectorRender, null), React.createElement(LightBox$1, {
      ref: _lightBoxRef,
      images: images,
      reactModalStyle: reactModalStyle
    }));
  };
  return ImagesGrid;
}(Component);
export { ImagesGrid as MuiFbPhotoGrid };